module.exports = __webpack_public_path__ + "static/media/mg.ab73662e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mg.svg
// module id = 882
// module chunks = 0